import React from 'react';
import RackSelectorOption from './RackSelectorOption';

const RackSelector = ({
  translations,
  filters,
  selectionText,
  handleProductSelect,
  defaultButtonText,
  defaultButtonCallback,
  secondaryButtonCallback,
  secondaryButtonText,
}) => {
  return (
    <div className="bar-select-container">
      <div className="modal-heading heading3">{translations.SelectRoofRackHeader}</div>
      <div className="bar-container">
        {filters.map((item, index) => (
          <RackSelectorOption
            key={index}
            name={item.Name}
            description={item.Description}
            icon={item.Icon}
            filterclassNames={item.FilterClassNames}
            filterInformation={item.FilterInformation}
            handleProductSelect={handleProductSelect}
            index={index}
            selectionText={selectionText}
          />
        ))}
        <div className={`bar-item`}>
          <div className="icon-container">
            <i className="le-icon-plus"></i>
          </div>
          <button className="btn bar-item-text" onClick={secondaryButtonCallback}>
            <span className="heading5">{secondaryButtonText}</span>
          </button>
        </div>
        <button className="btn bar-item--thirdparty" onClick={defaultButtonCallback}>
          <span className="paragraph">{defaultButtonText}</span>
        </button>
      </div>
    </div>
  );
};

export default RackSelector;
